import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';


@Injectable()
export class GestioneProfiliUtenteService {
  private http: HttpClient;
  constructor(http: HttpClient) {
    this.http = http;
  }

  private handleError(error: HttpResponse < any > | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error = new HttpResponse()) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = '${error.status} - ${error.statusText || \'\'} ${err}';
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return throwError(errMsg);
  }


}
